export function getDashboardUrl(): string {
  const envPrefix = getEnvPrefix(true)
  return `https://${envPrefix}dashboard.webwisdom.ai`
}

function getEnvPrefix(userVisible = true): string {
  const dwEnv = getDwEnv()

  if (dwEnv === 'local') {
    return 'staging-'
  } else if (dwEnv === 'prod' && userVisible) {
    return ''
  } else {
    return `${dwEnv}-`
  }
}

export async function submitConcierge(
  conciergeType: 'web' | 'content',
  primaryValue: string,
  email: string,
  product: string,
  via?: string,
): Promise<any> {
  try {
    const endpoint = getSubmitUrl(conciergeType)
    const bodyKey = conciergeType === 'web' ? 'url' : 'name'

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        [bodyKey]: primaryValue,
        email,
        product,
        type: conciergeType,
        ...(via ? { via } : {}),
      }),
    })
    return response
  } catch (error) {
    console.log(error)
  }
}

function getSubmitUrl(conciergeType: 'web' | 'content'): string {
  const baseUrl = getBaseUrl()
  return conciergeType === 'web'
    ? `${baseUrl}/submit/concierge`
    : `${baseUrl}/concierge/new`
}

function getBaseUrl(): string {
  const dwEnv = getDwEnv()
  if (dwEnv === 'local') {
    return `https://staging-api.digitalwisdom.ai`
  }
  return `https://${dwEnv}-api.digitalwisdom.ai`
}

export function getDwEnv(): string {
  const url = new URL(window.location.href)
  let dwEnv = url.searchParams.get('dwEnv')

  if (!dwEnv) {
    if (window.location.href.includes('localhost')) {
      dwEnv = 'local'
    } else if (
      window.location.href.includes('staging') ||
      window.location.href.includes('-digital-wisdom.vercel.app')
    ) {
      dwEnv = 'staging'
    } else {
      console.log(`No dwEnv found in query or ${window.location.href}`)
      dwEnv = 'prod'
    }
  }
  console.log(`Sign up is using ${dwEnv} environment`)
  return dwEnv
}

export function getConciergeType(): 'web' | 'content' {
  const url = new URL(window.location.href)
  const type = url.searchParams.get('type')
  return type === 'content' ? 'content' : 'web'
}
